import { lazy, Suspense } from "react";
import { createFileRoute } from "@tanstack/react-router";

// Monaco stays out of the main bundle: the editor is only loaded on this route.
const EditorPage = lazy(() => import("@/features/intercept/editor/editor-page"));

export const Route = createFileRoute("/_app/intercept/$name")({
  validateSearch: (search: Record<string, unknown>): { script?: number } => {
    const n = Number(search.script);
    return { script: Number.isInteger(n) && n > 0 ? n : undefined };
  },
  component: () => (
    <Suspense fallback={null}>
      <EditorPage />
    </Suspense>
  ),
});
